import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Button,
  Typography,
  IconButton,
  Checkbox,
  FormControlLabel,
  Switch,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

function ProductCard({
  product,
  handleEdit,
  handleDelete,
  handleFeaturedChange,
  handleVisibilityChange, // Nueva función para manejar cambios de visibilidad
}) {
  const [isFeatured, setIsFeatured] = useState(product.destacado);
  const [isVisible, setIsVisible] = useState(product.visible);

  const handleCheckboxChange = () => {
    const newFeaturedStatus = !isFeatured;
    setIsFeatured(newFeaturedStatus);
    handleFeaturedChange(product.id, newFeaturedStatus); // Llamamos a la función que actualiza el estado del producto
  };

  const handleSwitchChange = () => {
    const newVisibilityStatus = !isVisible;
    setIsVisible(newVisibilityStatus);
    handleVisibilityChange(product.id, newVisibilityStatus); // Llamada a la función que cambia el estado de visibilidad
  };

  return (
    <div className="col-12 col-sm-6 col-md-4 mb-4">
      <Card
        sx={{
          display: "flex",
          flexDirection: "row",
          height: "auto",
          backgroundColor: "#3e2d23",
          borderRadius: 2,
          boxShadow: 3,
          overflow: "hidden",
        }}
      >
        <CardMedia
          component="img"
          sx={{
            width: { xs: "40%", sm: "40%", md: "40%" },
            height: "auto",
            objectFit: "cover",
          }}
          image={product.imagenUrl}
          alt={product.nombre}
        />
        <CardContent
          sx={{
            padding: 2,
            textAlign: "center",
            width: { xs: "60%", sm: "60%", md: "60%" },
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Typography
            variant="h6"
            component="div"
            color="error"
            fontWeight="bold"
            sx={{ marginBottom: 1 }}
          >
            {product.nombre}
          </Typography>
          <Typography
            variant="body2"
            color="white"
            sx={{
              marginBottom: 1,
              height: "60px",
              overflow: "hidden",
            }}
          >
            {product.descripcion}
          </Typography>
          <Typography variant="body1" color="#DEAC6F" fontWeight="bold">
            €{product.precio}
          </Typography>

          <FormControlLabel
            control={
              <Checkbox
                checked={isFeatured}
                onChange={handleCheckboxChange}
                color="primary"
              />
            }
            label="Destacado"
            sx={{ color: "white", marginTop: 1 }}
          />

          <FormControlLabel
            control={
              <Switch
                checked={isVisible}
                onChange={handleSwitchChange}
                color="success"
              />
            }
            label="Visible"
            sx={{ color: "white", marginTop: 1 }}
          />

          <div style={{ marginTop: "10px" }}>
            <Button
              variant="contained"
              color="error"
              size="small"
              sx={{
                marginBottom: 1,
                width: "100%",
                borderRadius: 20,
              }}
              onClick={() =>
                alert(
                  `Producto: ${product.nombre}\nDescripción: ${product.descripcion}`
                )
              }
            >
              Ver Detalles
            </Button>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <IconButton
                color="primary"
                onClick={() => handleEdit(product)}
                sx={{
                  marginRight: 1,
                }}
              >
                <EditIcon />
              </IconButton>

              <IconButton
                color="error"
                onClick={() => handleDelete(product.id)}
              >
                <DeleteIcon />
              </IconButton>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default ProductCard;
